import React from 'react';
import { Form } from '@tribeplatform/react-components/Form';
import { T, useStaticIntl, } from '@tribeplatform/react-components/i18n';
import { FormControl } from '@tribeplatform/react-ui-kit/FormControl';
import { Select } from '@tribeplatform/react-ui-kit/Select';
import { useBlock } from '../../hooks/index.js';
const alignmentsFactory = (intl) => [
    {
        value: 'center',
        text: intl.$t({ id: 'Generics.Center', defaultMessage: 'Center' }),
    },
    {
        value: 'left',
        text: intl.$t({ id: 'Generics.Left', defaultMessage: 'Left' }),
    },
];
const stylesFactory = (intl) => [
    {
        value: 'simple',
        text: intl.$t({ id: 'Generics.Simple', defaultMessage: 'Simple' }),
    },
    {
        value: 'vibrant',
        text: intl.$t({ id: 'Generics.Vibrant', defaultMessage: 'Vibrant' }),
    },
];
export const AnnouncementBlockSettings = () => {
    const { block: { props: { viewStyle, align, hidden }, }, upsertProp, } = useBlock();
    const alignments = useStaticIntl(alignmentsFactory);
    const styles = useStaticIntl(stylesFactory);
    return (React.createElement(Form, { onChange: e => {
            upsertProp(e.target.name, e.target.value);
        }, defaultValues: {
            viewStyle,
            align,
            hidden,
        } },
        React.createElement("div", { className: "flex flex-col space-y-5" },
            React.createElement(FormControl.Select, { name: "viewStyle", value: viewStyle, onChange: (value) => {
                    upsertProp('viewStyle', value);
                    return value;
                }, label: React.createElement(T, { id: "Generics.ViewStyle", defaultMessage: "View style" }) },
                React.createElement(Select.Button, null, styles.find(s => s.value === viewStyle).text),
                React.createElement(Select.Items, null, styles.map(style => (React.createElement(Select.Item, { key: style.value, value: style.value }, style.text))))),
            React.createElement(Form.Input, { name: "title", label: React.createElement(T, { id: "Generics.Title", defaultMessage: "Title" }) }),
            React.createElement(Form.Textarea, { name: "description", label: React.createElement(T, { id: "Generics.Description", defaultMessage: "Description" }) }),
            React.createElement(Form.Input, { name: "actionText", label: React.createElement(T, { id: "Generics.ButtonText", defaultMessage: "Button Text" }) }),
            React.createElement(Form.Input, { name: "actionUrl", label: React.createElement(T, { id: "Generics.ButtonLink", defaultMessage: "Button Link" }) }),
            React.createElement(FormControl.Select, { name: "align", value: align, onChange: (value) => {
                    upsertProp('align', value);
                    return value;
                }, label: React.createElement(T, { id: "Generics.TextAlign", defaultMessage: "Text align" }) },
                React.createElement(Select.Button, null, alignments.find(a => a.value === align).text),
                React.createElement(Select.Items, null, alignments.map(align => (React.createElement(Select.Item, { key: align.value, value: align.value }, align.text))))),
            React.createElement(Form.Toggle, { label: React.createElement(T, { id: "Generics.Hidden", defaultMessage: "Hidden" }), name: "hidden", onChange: value => {
                    upsertProp('hidden', value);
                    return value;
                }, checked: hidden }))));
};
//# sourceMappingURL=Settings.js.map